import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import { Table } from "reactstrap";
import { GetCookieToken } from "../Cookie/GetCookie";
import FadeIn from "react-fade-in/lib/FadeIn";
import { toThaiDate } from "../../helpers/date_helper";
import { addDays } from "date-fns";
import LoadingData from "../TESTPage/LoadingData";
import { ChunkArray } from "../Function/ChunkArray";

const API_URL = process.env.REACT_APP_API_CORS;

function SummaryTimeGroup(props) {
  const { orgID, orgName } = props;
  const [SummaryStartTime, setSummaryStartTime] = useState([]);
  const [loading, setLoading] = useState([]);
  // const [chunkThTd, setChunkThTd] = useState();
  // const [chunkThTdPage, setChunkThTdPage] = useState();
  const token = GetCookieToken("userToken");
  const fetchData = async () => {
    setLoading(true)
    const urlstartTime = `${API_URL}/api/time/history/startTime/${orgID}`;
    await axios
      .get(urlstartTime, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        setSummaryStartTime(response.data.result);
        setTimeout(() => {
          setLoading(false)
        }, 1000);
      });
  };
  useEffect(() => {
    if (orgID !== null && orgID !== undefined) {
      fetchData();
    }
  }, [orgID]);

  // useEffect(() => {
  //   setChunkThTd(ChunkArray(SummaryStartTime, 20));
  //   setChunkThTdPage(ChunkArray(SummaryStartTime, 20)?.length);
  // }, [SummaryStartTime])
  

  return (
    <Fragment>
      {SummaryStartTime !== null &&
      SummaryStartTime !== undefined &&
      SummaryStartTime.length !== 0 && !loading ? (
        <FadeIn>
          <Table>
            <thead>
              <tr>
                <th>กลุ่ม/กอง</th>
                <th>รอบการเข้างาน</th>
                <th>วันที่เริ่ม</th>
                <th>วันที่สิ้นสุด</th>
              </tr>
            </thead>
            <tbody>
              {SummaryStartTime.map((item, idx) => {
                const DStart = toThaiDate(String(item.start_date));

                let DEnd;
                const orignDEnd = SummaryStartTime[idx - 1]?.start_date;
                if (orignDEnd !== undefined && orignDEnd !== null) {
                  const currentDate = new Date(orignDEnd);
                  const newDate = addDays(currentDate, -1);
                  DEnd = toThaiDate(newDate);
                }

                return (
                  <tr key={idx}>
                    <td>{orgName}</td>
                    <td>{item.user_start_work_name}</td>
                    <td>{DStart.split(" 0:00:00")[0]}</td>
                    <td>
                      {DEnd !== null && DEnd !== undefined
                        ? DEnd.split(" 0:00:00")[0]
                        : ""}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </FadeIn>
      ) : (
        orgID !== null && orgID !== undefined && loading &&
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "200px" }}> <LoadingData /> </div>
      )}
    </Fragment>
  );
}

export default SummaryTimeGroup;
